<section id="destinations" class="w-full pb-15 bg-white border-b-2 border-primary-500">

    @if(view.page) {
    <!-- Header image with smooth flowing bottom -->
    <div class="relative w-screen h-[56.25vw] max-h-[600px] overflow-hidden">
        <!-- Layer 1 -->
        <img [src]="view.imageLayer1" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />

        <!-- Layer 2 -->
        <img [src]="view.imageLayer2" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />

        <!-- Flowing wave SVG cut -->
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
            <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
        </svg>
    </div>
    }

    <!-- Loading State -->
    @if (view.isLoading) {
    <div class="flex flex-col items-center justify-center mb-10 md:mt-5 lg:mt-10">
        <div class="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-primary-500"></div>
    </div>
    }
    
    @if (view.railBundles && view.railBundles.length > 0) {
    <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 px-4 md:px-8 lg:px-15 mt-15">
        @for(bundle of view.railBundles; track bundle) {
        @if (bundle.nights > 0) {
        <fuse-card class="flex flex-col w-full w-{350} mx-auto  overflow-hidden shadow-lg hover:shadow-xl ">
            <div class="relative">
                <img class="w-full h-60" [src]="bundle.imageUrls[0]" alt="Package Image">
                <div class="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-900/40"></div>
                <div class="absolute top-0 right-0 text-white px-8 py-5 text-xl tracking-wider custom_font">
                    {{bundle.supplier ? bundle.destinationName : bundle.destination}}</div>
                <div class="flex absolute top-0 right-0 justify-center items-center px-8 py-15">
                    @if(bundle.priceAccommodation) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Accommodation'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceFlights && !bundle.excludeFlights) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Flights'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:airplanemode_active'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceCars) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Car Rental'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:directions_car'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceTransfers) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Transfers'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceCruises) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Cruise'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:directions_boat'"></mat-icon>
                    </div>
                    }
                </div>
            </div>
            <div class="flex flex-col justify-center bg-white dark:bg-slate-800 p-4">
                <div class="flex mb-2 h-4">
                    @if(bundle.supplier && bundle.supplier.grading > 0 && bundle.supplier.grading <= 1) { <mat-icon
                        class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                        }
                        @if(bundle.supplier && bundle.supplier.grading > 1 && bundle.supplier.grading <= 2) { <mat-icon
                            class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                            <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                            }
                            @if(bundle.supplier && bundle.supplier.grading > 2 && bundle.supplier.grading <= 3) {
                                <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'">
                                </mat-icon>
                                <mat-icon class="icon-size-5 text-yellow-500"
                                    [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                <mat-icon class="icon-size-5 text-yellow-500"
                                    [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                }
                                @if(bundle.supplier && bundle.supplier.grading > 3 && bundle.supplier.grading <= 4) {
                                    <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'">
                                    </mat-icon>
                                    <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    }
                                    @if(bundle.supplier && bundle.supplier.grading > 4 && bundle.supplier.grading <= 5)
                                        { <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        }
                </div>
                <p class="text-2xl custom_font font-semibold mb-2 h-14">{{bundle.supplier ? bundle.supplier.name :
                    bundle.name}}</p>
                <div class="flex gap-2 py-2">
                    @if (bundle.tagsArray) {
                    <div class="flex flex-wrap gap-2">
                        @for (tag of bundle.tagsArray; track $index) {
                        <span
                            class="justify-center items-center bg-accent-500 text-white text-sm rounded-full py-1 px-3 inline-block w-fit">
                            {{ tag }}
                        </span>
                        }
                    </div>
                    }
                    @if(bundle.basis) {
                    <div class="flex flex-wrap gap-2">
                        <span
                            class="justify-center items-center bg-primary-500 text-white text-sm rounded-full py-1 px-3 inline-block w-fit">
                            {{ bundle.basis }}
                        </span>
                    </div>
                    }
                </div>

                <div class="flex items-center justify-between">
                    <div class="flex flex-col space-y-2">
                        <p class="text-gray-500">{{bundle.nights}} {{bundle.nights === 1 ? 'Night' :
                            'Nights'}}</p>
                        <p class="text-gray-500">From<span
                                class="text-primary-500 text-2xl font-semibold ml-2">{{bundle.priceBundleTotal |
                                currency:(displayCurrencyCode || bundle.currency):'symbol-narrow'}}</span><sup
                                class="text-gray-500 ml-1">pps</sup></p>
                    </div>
                    <a [routerLink]="['/package', bundle.id, bundle.slug ? bundle.slug : slugify(bundle.name)]"
                        type="button"
                        class="ring-2 ring-accent-500 rounded-lg text-sm md:text-md font-bold py-1 md:py-2 px-2 transition transition-duration: 500ms hover:bg-accent-500 hover:text-primary-100">View
                        More</a>
                </div>
            </div>
        </fuse-card>
        }
        }
    </div>
    } 
    
</section>